import React, { useCallback } from "react"

import { Switch } from "@coval/ui"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import type { WebSocketFieldProps } from "./types"

export const SpeechActivityFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const isEnabled = Boolean(metadata.speech_activity_enabled)

  const handleToggle = useCallback(
    (checked: boolean) => {
      onMetadataUpdate({ speech_activity_enabled: checked })
    },
    [onMetadataUpdate],
  )

  return (
    <div className="flex items-center gap-3">
      <Switch
        id="speech-activity-enabled"
        checked={isEnabled}
        onCheckedChange={handleToggle}
        disabled={disabled}
      />
      <div className="flex flex-col gap-1">
        <FieldLabel htmlFor="speech-activity-enabled">
          Speech Activity Markers
        </FieldLabel>
        <p className="text-xs text-coval-text-muted">
          When enabled, {`{"type": "utterance_started", "utterance_id": "..."}`}{" "}
          and {`{"type": "utterance_end", ...}`} messages are sent to the agent
          as the simulated caller starts and stops speaking.
        </p>
      </div>
    </div>
  )
}
